import { Schema } from 'effect';
import { z } from 'zod';
export var FFALicenseType;
(function (FFALicenseType) {
    FFALicenseType["COMP"] = "COMP";
    FFALicenseType["ENTR"] = "ENTR";
    FFALicenseType["LOISR"] = "LOISR";
    FFALicenseType["LOISS"] = "LOISS";
    FFALicenseType["DECO"] = "DECO";
    FFALicenseType["ENCA"] = "ENCA";
    FFALicenseType["PPS"] = "PPS";
})(FFALicenseType || (FFALicenseType = {}));
export var FFAErrorCode;
(function (FFAErrorCode) {
    FFAErrorCode["PRO001"] = "PROx001";
    FFAErrorCode["PRO002"] = "PROx002";
    FFAErrorCode["PRO003"] = "PROx003";
    FFAErrorCode["PRO004"] = "PROx004";
    FFAErrorCode["PRO005"] = "PROx005";
    FFAErrorCode["PRO006"] = "PROx006";
    FFAErrorCode["PRO007"] = "PROx007";
    FFAErrorCode["PRO008"] = "PROx008";
    FFAErrorCode["PRO009"] = "PROx009";
    FFAErrorCode["PRO010"] = "PROx010";
    FFAErrorCode["PRO011"] = "PROx011";
    FFAErrorCode["PRO012"] = "PROx012";
    FFAErrorCode["PRO013"] = "PROx013";
    FFAErrorCode["PRO014"] = "PROx014";
    FFAErrorCode["PRO015"] = "PROx015";
    FFAErrorCode["PRO016"] = "PROx016";
    FFAErrorCode["PRO017"] = "PROx017";
    FFAErrorCode["PRO018"] = "PROx018";
    FFAErrorCode["PRO019"] = "PROx019"; // Undocumented but returned by API
})(FFAErrorCode || (FFAErrorCode = {}));
export const CheckFFALicenseNumberSchema = z.object({
    raceSlug: z.string(),
    attendee: z.object({
        firstName: z.string(),
        lastName: z.string(),
        gender: z.enum(['MALE', 'FEMALE']),
        ffaLicenseNumber: z.string(),
        birthDate: z.string()
    })
});
export const CheckFFALicenseEnvVarsSchema = z.object({
    FFA_API_UID: z.string(),
    FFA_API_PASSWORD: z.string(),
    FFA_API_URL: z.string()
});
const _FFALicenseResponseSchema = Schema.Struct({
    infoFlag: Schema.Boolean,
    relFlag: Schema.Boolean,
    mutFlag: Schema.Boolean,
    certifFlag: Schema.Boolean,
    raceInputId: Schema.NullOr(Schema.String),
    idActExt: Schema.NullOr(Schema.String),
    idCmpExt: Schema.NullOr(Schema.String),
    relationNumber: Schema.NullOr(Schema.String),
    name: Schema.NullOr(Schema.String),
    firstName: Schema.NullOr(Schema.String),
    gender: Schema.NullOr(Schema.String),
    birthDate: Schema.NullOr(Schema.String),
    nationality: Schema.NullOr(Schema.String),
    licenseType: Schema.NullOr(Schema.Enums(FFALicenseType)),
    endDate: Schema.NullOr(Schema.String),
    category: Schema.NullOr(Schema.String),
    clubId: Schema.NullOr(Schema.String),
    shortClubName: Schema.NullOr(Schema.String),
    clubName: Schema.NullOr(Schema.String),
    masterClubId: Schema.NullOr(Schema.String),
    shortMasterClubName: Schema.NullOr(Schema.String),
    masterClubName: Schema.NullOr(Schema.String),
    enterpriseClubId: Schema.NullOr(Schema.String),
    shortEnterpriseClubName: Schema.NullOr(Schema.String),
    enterpriseClubName: Schema.NullOr(Schema.String),
    department: Schema.NullOr(Schema.String),
    league: Schema.NullOr(Schema.String),
    errorMessage: Schema.NullOr(Schema.String)
});
export const FFALicenseResponseSchema = _FFALicenseResponseSchema;
